import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';
import {
  IntegrationCodeRequest,
  IntegrationCodeSaveRequest
} from '@/main/models/request';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import {
  IntegrationCodeEditedResponse,
  IntegrationCodeResponse
} from '@/main/models/response';

export abstract class IIntegrationCodeApi {
  abstract domain(): Promise<AxiosResponse<Result<KeyValue>>>;
  abstract searchGrid(
    request: IntegrationCodeRequest
  ): Promise<AxiosResponse<PaginationResponse<IntegrationCodeResponse>>>;
  abstract getIntegrationCodeByGuid(
    guidintegrationCodeRequest: string
  ): Promise<AxiosResponse<Result<IntegrationCodeEditedResponse>>>;
  abstract saveIntegrationCode(
    request: IntegrationCodeSaveRequest
  ): Promise<AxiosResponse<Result<void>>>;
}

